import React, { useEffect, useState } from 'react';
import { useModal } from '@components/ModalHook';
import { Row, Col } from 'antd';
import dayjs from 'dayjs';
import BriefcaseIcon from '@components/Icons/BriefcaseIcon';
import LocationIcon from '@components/Icons/LocationIcon';
import TimeIcon from '@components/Icons/TimeIcon';
import EducationIcon from '@components/Icons/EducationIcon';
import ObjectiveIcon from '@components/Icons/ObjectiveIcon';
import EyeIcon from '@components/Icons/EyeIcon';
import PersonSearchIcon from '@components/Icons/PersonSearchIcon';
import { MODAL_VIEW_RESUME } from '@components/UserCV/ResumeViewer';
import { ImageThumbnailRatio } from '@components/ImageThumbnailRatio';
import styles from './Recruitment.module.scss';
import RenderListItemEducation from './RenderListItemEducation';
import RenderListItemExperience from './RenderListItemExperience';
import RenderListItemObjective from './RenderListItemObjective';

export const renderSplitString = (string) => {
  if (!string) return;

  if (string === '') return;
  
  const array = string.split("\n") || [];
  
  return (
    <ul>
      {array.map((item, index) => {
        return <li key={index} className={styles.descriptionItem}>{item}</li>
      })}
    </ul>
  );
};

export const countExperience = (experience) => {
  let time = 0;
  experience.forEach(item => {
    const date1 = dayjs(item.rangeTime[1]);
    const date2 = dayjs(item.rangeTime[0]);
    time = time + date1.diff(date2, 'month');
  });
  return time;
};

export const renderTimeLastModified = (time) => {
  const now = dayjs();
  const lastModified = time;
  if (now.diff(lastModified, 'day') >= 1) {
    return `${now.diff(lastModified, 'day')} ngày trước`
  };
  if (now.diff(lastModified, 'hour') >= 1) {
    return `${now.diff(lastModified, 'hour')} giờ trước`
  };
  if (now.diff(lastModified, 'minute') >= 1) {
    return `${now.diff(lastModified, 'minute')} phút trước`
  };
  return `${now.diff(lastModified, 'second')} giây trước`
};

//Duong Van Anh --> Anh D.
export const renderModifiedName = (name) => {
  if (!name || name === '') return name;

  const arrayNameSplit = name.split(' ');

  if (arrayNameSplit.length < 2) {
    return name;
  } 
  
  const firstNameFirstLetter = name.charAt(0);
  const lastName = arrayNameSplit[arrayNameSplit.length - 1];

  return `${lastName} ${firstNameFirstLetter}.`;
};

const Applicants = ({item}) => {
  if (!item) return;
  const [, showModalViewResume] = useModal(MODAL_VIEW_RESUME);
  const [viewResumeCount, setViewResumeCount] = useState(0);
  const [openContactResumeCount, setOpenContactResumeCount] = useState(0);
  
  const {
    name,
    jobSearchStatus,
    avatarUrl, 
    careerGoals,
    education,
    experience, 
    locationWork,
    profession,
    viewCount,
    openContactCount,
    lastUpdateResume
  } = item;
  
  const modifiedName = renderModifiedName(name);
  const locationWorkRender = JSON.parse(locationWork) || [];
  const experienceRender = JSON.parse(experience);
  const educationRender = JSON.parse(education);
  
  const yearExperience = Math.floor(countExperience(experienceRender) / 12);
  const monthExperience = countExperience(experienceRender) - yearExperience * 12;
  const experienceString = `(${yearExperience === 0 ? '' : yearExperience + ' năm' }
    ${monthExperience === 0 ? '' : monthExperience + ' tháng' })
  `;
  
  useEffect(() => {
    setViewResumeCount(viewCount);
    setOpenContactResumeCount(openContactCount)
  }, []);

  return (
    <div className={styles.wrapper}>
      <Row>
        <Col
          sm={{ span: 6 }} 
          md={{ span: 3 }}
          className={styles.profileAvatar}
        >
          <div
            onClick={() => showModalViewResume({
              resume: item, 
              setViewResume: setViewResumeCount,
              setOpenContactResumeCount: setOpenContactResumeCount,
              isViewResume: true
            })}
            className={styles.avatarWrapper}
          >
            <ImageThumbnailRatio 
              src={avatarUrl}
              alt={name}
              ratio='1:1'
              
            />
          </div>
        </Col>

        <Col
          sm={{ span: 18 }} 
          md={{ span: 7 }}
          className={styles.personalInformation}
        >
          <h2 
            onClick={() => showModalViewResume({
              resume: item, 
              setViewResume: setViewResumeCount,
              setOpenContactResumeCount: setOpenContactResumeCount,
              isViewResume: true
            })}
            className={styles.name}
          >
            {modifiedName}
          </h2>

          {jobSearchStatus && <div className={styles.jobSearchStatus}>Đang tìm việc</div>}
          
          <div>
            <div className={styles.icon}>
              <BriefcaseIcon />
            </div>              
            <i>{profession}</i>
          </div>
          {locationWorkRender.length > 0 &&
            <div>
              <div className={styles.icon}>
                <LocationIcon />
              </div>
              <i>{locationWorkRender.join(', ')}</i>
            </div>
          
          }
          <div>
            <div className={styles.icon}>
              <TimeIcon />
            </div>
            Cập nhật: {renderTimeLastModified(lastUpdateResume)}
          </div>

          {viewResumeCount > 0 &&
            <div>
              <div className={styles.icon}>
                <EyeIcon />
              </div>
              {viewResumeCount} lượt xem
            </div>
          }

          {openContactResumeCount > 0 && 
            <div>
              <div className={styles.icon}>
                <PersonSearchIcon />
              </div>
              {openContactResumeCount} lượt mở liên hệ
            </div>
          }
        </Col>

        <Col
          sm={{ span: 24 }} 
          md={{ span: 14 }}
          className={styles.experienceInformation}
        >
          <div>
            <div className={styles.header}>
              <div className={styles.icon}>
                <BriefcaseIcon />
              </div>              
              Kinh nghiệm: <i>{experienceString}</i>
            </div>
            <RenderListItemExperience list={experienceRender} />
          </div>

          <div>
            <div className={styles.header}>
              <div className={styles.icon}>
                <EducationIcon />
              </div>                
              Học vấn
            </div>
            <RenderListItemEducation list={educationRender} />
          </div>

          <div>
            <div className={styles.header}>
              <div className={styles.icon}>
                <ObjectiveIcon />
              </div>
              Mục tiêu sự nghiệp
            </div>
            <div>
              <RenderListItemObjective list={careerGoals.split("\n") || []} />
            </div>
          </div>
        </Col>

      </Row>
    </div>
  )
};
export default Applicants;